import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RightPanelDialog } from '../side-dialog';
import { CustomizationEditorComponent } from './components/customization-editor/customization-editor.component';
import { Customization } from './actions/reducers';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomizationService {
  constructor(
    private store: Store<{ customization: { customization: Customization } }>,
    private dialog: RightPanelDialog
  ) {
    store.pipe(select('customization', 'customization')).subscribe((res) => {
      console.log('customization constructed');

      console.log(res);
      for (const entry in res) {
        document.body.style.setProperty(`--${entry}`, res[entry]);
      }
    });
  }

  openEditor() {
    const ref = this.dialog.openRight(CustomizationEditorComponent, {
      backdropClass: 'cdk-overlay-transparent-close-cursor-backdrop',
    });
    ref.componentInstance.closeMe
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => ref.close());
    return ref;
  }

  updateProperty(property, value) {
    console.log(property, value);
    document.body.style.setProperty(`--${property}`, value);
  }
}
